import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api.js';

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [state, setState] = useState({ status: 'loading', years: [], error: null });

  const load = useCallback(async () => {
    setState((prev) => ({ ...prev, status: prev.years.length ? prev.status : 'loading' }));
    try {
      const data = await api.content();
      setState({ status: 'ready', years: data.years || [], error: null });
    } catch (error) {
      setState({ status: 'error', years: [], error: error.message });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ContentContext.Provider value={{ ...state, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const context = useContext(ContentContext);
  if (!context) throw new Error('useContent musí být uvnitř <ContentProvider>');
  return context;
}

/**
 * Vrátí ročník podle slugu z URL; bez slugu ten označený jako aktuální.
 * `archived` říká, jestli se na stránku díváme jako na archiv.
 */
export function useYear(slug) {
  const { years, status, error } = useContent();
  const year = slug
    ? years.find((y) => y.slug === slug)
    : years.find((y) => y.isCurrent) || years[0];

  return { year, archived: Boolean(slug) && !year?.isCurrent, status, error };
}
